<template>
  <v-dialog v-model="dialogOpen" width="750">
    <v-card :loading="currentLeadQuoteLoading">
      <v-card-title>Quote</v-card-title>
      <template v-if="!currentLeadQuoteLoading">
        <v-card-text v-html="currentLeadQuote"></v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" small @click="send" :disabled="currentLeadSendQuoteLoading" :loading="currentLeadSendQuoteLoading">Send</v-btn>
          <v-btn color="primary" outlined small @click="close">cancel</v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template> 

<script>
  import { mapActions,mapState } from "vuex";
  export default {
    props: ['lead_id','dialogOpen'],
    computed: {
      ...mapState('leads',['currentLeadQuoteLoading','currentLeadQuote','currentLeadSendQuoteLoading']),
    },
    watch: {
      async dialogOpen(val) {
        if(val){
          await this.getQuoteByLeadID(this.lead_id);
        }
      }
    },
    methods: {
      ...mapActions('leads',['getQuoteByLeadID','sendLeadQuoteByID']),
      close() {
        this.$emit('close-dialog');
      },
      async send() {
        await this.sendLeadQuoteByID(this.lead_id);
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
